import { memo } from 'react';
import { Button, Flexbox, Icon, Tooltip, Typography } from '@hiiretail/synergy-ui';
import { RowActionsComponent } from './RowActions.types';
import { AccessControl } from '../AccessControl/AccessControl';
import { AccessDeniedButton } from '../../styles/AccessDenied.styles';

export const RowActions: RowActionsComponent = memo(
  ({
    original,
    setItemToUpdate,
    toggleUpdateItemModal,
    updatePermission,
    onUpdateButtonClick,
    disabled,
    children,

    onDeleteButtonClick,
    toggleDeleteItemModal,
    setItemToDelete,
    deletePermission,
  }) => (
    <Flexbox container gutter={2} justifyContent="center">
      <AccessControl
        permission={updatePermission}
        renderIfNoAccess={
          <Tooltip
            title={
              <Typography variant="caption" color={() => 'white'}>
                You do not have permissions to perform this action.
                <br />
                Required permissions: {/*@ts-ignore*/}
                <Typography variant="caption" weight="bold">
                  {updatePermission}
                </Typography>
              </Typography>
            }
          >
            <AccessDeniedButton variant="icon" data-testid="update-tenant" disabled>
              <Icon.Edit size="sm" color={() => '#757575'} />
            </AccessDeniedButton>
          </Tooltip>
        }
      >
        <Button
          variant="icon"
          data-testid="update-tenant"
          disabled={disabled}
          onClick={() => {
            if (onUpdateButtonClick) {
              onUpdateButtonClick(original);
            } else {
              setItemToUpdate(original);
              toggleUpdateItemModal();
            }
          }}
        >
          {children ? children : <Icon.Edit size="sm" />}
        </Button>
      </AccessControl>

      {(onDeleteButtonClick || (setItemToDelete && toggleDeleteItemModal)) && (
        <AccessControl
          permission={deletePermission}
          renderIfNoAccess={
            <Tooltip
              title={
                <Typography variant="caption" color={() => 'white'}>
                  You do not have permissions to perform this action.
                  <br />
                  Required permissions: {/*@ts-ignore*/}
                  <Typography variant="caption" weight="bold">
                    {deletePermission}
                  </Typography>
                </Typography>
              }
            >
              <AccessDeniedButton variant="icon" data-testid="delete-entity-row-action" disabled>
                <Icon.Delete size="sm" color={() => '#757575'} />
              </AccessDeniedButton>
            </Tooltip>
          }
        >
          <Button
            variant="icon"
            data-testid="delete-entity-row-action"
            disabled={disabled}
            onClick={() => {
              if (onDeleteButtonClick) {
                onDeleteButtonClick(original);
              } else {
                if (setItemToDelete && toggleDeleteItemModal) {
                  setItemToDelete(original);
                  toggleDeleteItemModal();
                }
              }
            }}
          >
            {children ? children : <Icon.Delete size="sm" />}
          </Button>
        </AccessControl>
      )}
    </Flexbox>
  ),
);
